// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { playfiAlbireo as _playfiAlbireo } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the playfiAlbireo chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1612127
 * Chain Name: PlayFi Albireo Testnet
 * Default Block Explorer: https://albireo-explorer.playfi.ai
 * Default RPC URL: https://albireo-rpc.playfi.ai
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { playfiAlbireo } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: playfiAlbireo,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const playfiAlbireo = createCommon({
	..._playfiAlbireo,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
